import { Box, Container, Typography, Grid } from "@mui/material";
import CasinoIcon from "@mui/icons-material/Casino";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import CelebrationIcon from "@mui/icons-material/Celebration";

const features = [
  {
    icon: <EmojiEventsIcon sx={{ fontSize: 36 }} />,
    title: "Πολλά Βραβεία",
    description: "Πρόσθεσε όσα έπαθλα θέλεις σε κάθε λοταρία",
  },
  {
    icon: <CelebrationIcon sx={{ fontSize: 36 }} />,
    title: "Γιορτινή Κίνηση",
    description:
      "Απόλαυσε όμορφες κινούμενες εικόνες με χριστουγεννιάτικο θέμα",
  },
  {
    icon: <CasinoIcon sx={{ fontSize: 36 }} />,
    title: "Δίκαιο & Τυχαίο",
    description: "Πλήρως τυχαίες και δίκαιες κληρώσεις λοταρίας",
  },
];

export const Features = () => {
  return (
    <Box
      sx={{
        bgcolor: "hsl(150, 60%, 25%)",
        color: "white",
        py: { xs: 6, md: 8 },
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          sx={{
            fontFamily: '"Mountains of Christmas", cursive',
            textAlign: "center",
            mb: 6,
            fontSize: { xs: "2rem", md: "2.5rem" },
          }}
        >
          ✨ Δυνατότητες ✨
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {features.map((feature, index) => (
            <Grid size={{ xs: 12, sm: 4 }} key={index}>
              <Box sx={{ textAlign: "center" }}>
                <Box
                  sx={{
                    width: 70,
                    height: 70,
                    borderRadius: "50%",
                    bgcolor: "rgba(255,255,255,0.15)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mx: "auto",
                    mb: 2,
                  }}
                >
                  {feature.icon}
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontFamily: '"Mountains of Christmas", cursive',
                    mb: 1,
                  }}
                >
                  {feature.title}
                </Typography>
                <Typography sx={{ opacity: 0.9 }}>
                  {feature.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
